import type { HeaderFeatureCommonProps, ResponsiveStyledProps } from "./types";

export const getResponsiveProps = (props: HeaderFeatureCommonProps): ResponsiveStyledProps => ({
  $display: props.display,
  $hideOnSwap: props.hideOnSwap,
  $shouldSwap: props.shouldSwap,
  $showIn: props.showIn,
  $showOnSwap: props.showOnSwap,
});
